import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'

import NoResultsIllustration from 'core/ui/assets/illustration-magnifying-glass.svg'

export function EmptyShipmentChargesState() {
  return (
    <Layout.Box
      backgroundColor="color-background-primary"
      borderWidth="border-thin"
      borderColor="color-border"
      borderRadius="border-radius-s"
      padding="spacing-10"
    >
      <Layout.Group align="center" justify="center">
        <EmptyState
          variant="panel"
          illustration={NoResultsIllustration}
          title="No rates available"
        />
      </Layout.Group>
    </Layout.Box>
  )
}
